


























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import cCard from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';

import Subcontractor from '@/classes/CRM/Subcontractor';
import notificationService from '@/services/notificationService';
import SubcontractorTeamPopup from '@/components/crm/subcontractor/popups/SubcontractorTeamPopup.vue';
import { Team, TeamsClient } from '@/data/web-api-client';

@Component({
  components: {
    Datagrid,
    cCard,
    SubcontractorTeamPopup,
  },
})
export default class SubcontractorTeamsCard extends Vue {
  @Prop({ required: true })
  public subcontractor!: Subcontractor;

  teams: Team[] = [];
  teamsClient: TeamsClient = new TeamsClient(undefined, this.$axios);

  addTeam() {
    var team = new Team();
    team.id = '';
    this.openTeamPopup(team);
  }

  public edit(e: any) {
    this.openTeamPopup(e.row.data);
  }

  public async remove(e: any) {
    await this.teamsClient.deleteTeam(e.data.id);
  }

  async mounted() {
    this.getTeams();
  }

  public async getTeams() {
    this.teams = await this.teamsClient.getAllTeamsSubcontractor(this.subcontractor.id!);
  }

  save(e: any) {
    const self = this;
    e.cancel = new Promise((resolve, reject) => {
      try {
        self.subcontractor.save();
        resolve(false);
      } catch (err) {
        notificationService.showAxiosError(err);
        resolve(true);
      }
    });
  }

  get columns() {
    return [
      {
        dataField: 'name',
        caption: this.$t('objects.subcontractors.fields.Name'),
      },
      {
        dataField: 'hourlyRate',
        caption: this.$t('objects.subcontractors.fields.HourlyRate'),
        format: CURRENCY_FORMAT,
        alignment: 'left',
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'wijzigen',
            icon: 'fas fa-edit',
            onClick: this.edit,
          },
          'delete',
        ],
      },
    ];
  }

  openTeamPopup(team: Team) {
    (this.$refs.SubcontractorTeamPopup as SubcontractorTeamPopup).Open(this.subcontractor, team);
  }
}
